import { currentUserApi } from '@entities/current-user/api/base';
import { orderApi } from '@entities/order/api/order-api';
import { organizationApi } from '@entities/organization/api/organization-api';
import { productApi } from '@entities/product/api/product-api';
import { requestApi } from '@entities/request/api/request-api';
import { userApi } from '@entities/user/api/user-management-api';
import { authApi } from '@shared/api/base/auth-base';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useResetCache = () => {
    const dispatch = useDispatch();

    const resetCache = () => {
        dispatch(userApi.util.resetApiState());
        dispatch(organizationApi.util.resetApiState());
        dispatch(currentUserApi.util.resetApiState());
        dispatch(authApi.util.resetApiState());
        dispatch(requestApi.util.resetApiState());
        dispatch(productApi.util.resetApiState());
        dispatch(orderApi.util.resetApiState());
    };

    useEffect(() => {
        resetCache();
        return () => {
            resetCache();
        };
    }, []);
};
